export default "__VITE_ASSET__cP7lDCjG__"